import { PayloadAction } from "@reduxjs/toolkit";
import { ItemId } from "../../../../../utl/models/ItemId";
import { UpsellState } from "../models/UpsellsState";

const setNewItemId = (state: UpsellState, action: PayloadAction<ItemId>) => {
    state.newItemId = action.payload.id;
}

export default setNewItemId;